import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center gap-10 overflow-hidden md:flex-row" }

import { useI18n } from 'vue-i18n';
    import PageCard from '@/components/PageCard.vue';
    import type { Company } from '@/types';
    import CustomerDashboardStats from './CustomerDashboardStats.vue';
    import CustomerDashboardMarquee from './CustomerDashboardMarquee.vue';
    import CustomerDashboardContacts from './CustomerDashboardContacts.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardBanner',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageCard, { class: "mb-0 flex-none" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomerDashboardStats, { company: _ctx.company }, null, 8, ["company"]),
        _createVNode(CustomerDashboardMarquee, { company: _ctx.company }, null, 8, ["company"]),
        _createVNode(CustomerDashboardContacts, { company: _ctx.company }, null, 8, ["company"])
      ])
    ]),
    _: 1
  }))
}
}

})